export enum UserActionTypeDownloaded {
  DriveFileDownloaded = 'DriveFileDownloaded',
  MailFileDownloaded = 'MailFileDownloaded',
  SharePointFileDownloaded = 'SharePointFileDownloaded',
  TeamDrivesFileDownloaded = 'TeamDrivesFileDownloaded'
}
